import React, { ReactElement } from "react";
import styles from "./avatarGroup.module.scss";
import { type IContent } from "@kunduz/data-access-cms-api";

export const PlanDetailAvatarGroup = (props: Props): ReactElement => {
  return (
    <>
      {props.data.title && <p className={styles.title}>{props.data.title}</p>}

      <div className={styles.avatarList}>
        {props.data.images?.map((av, i) => (
          <div className={styles.singleAvatar} key={`avatar_${i}`}>
            <img
              src={av.image}
              alt={av.title}
              className={styles.avatar}
              loading="lazy"
            />
            <div className={styles.textAndSupport}>
              <p className={styles.title}>
                {av.title}{" "}
                {av.icon && (
                  <img
                    src={av.icon}
                    className={styles.icon}
                    alt=""
                    loading="lazy"
                  />
                )}
              </p>
              <p className={styles.description}>{av.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
